import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ServicesPage() {
  const services = [{
    id: 'gebaeudereinigung',
    title: 'Gebäudereinigung',
    description: 'Professionelle Reinigung für Ihre Immobilien. Wir sorgen für Sauberkeit, Hygiene und Wohlbefinden in Ihren Räumlichkeiten.',
    features: ['Unterhaltsreinigung (Büros, Praxen)', 'Grundreinigung', 'Bedarfsreinigung', 'Treppenhausreinigung'],
    image: 'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?auto=format&fit=crop&q=80'
  }, {
    id: 'glasreinigung',
    title: 'Glas- & Fassadenreinigung',
    description: 'Streifenfreier Durchblick und gepflegte Fassaden. Wir reinigen Glasflächen jeder Art und Größe, auch in schwierigen Höhen.',
    features: ['Fensterreinigung', 'Glasfassaden', 'Wintergärten', 'Einsatz von CleanCopter Drohnentechnologie'],
    image: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&q=80'
  }, {
    id: 'spezialreinigung',
    title: 'Spezialreinigung',
    description: 'Für besondere Anforderungen bieten wir spezialisierte Lösungen an, um Ihre Werte langfristig zu erhalten.',
    features: ['Teppichbodenreinigung', 'Polsterreinigung', 'Baureinigung / Neubaureinigung', 'Industriereinigung'],
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?auto=format&fit=crop&q=80'
  }, {
    id: 'hygiene',
    title: 'Hygiene & Desinfektion',
    description: 'Maximale Sicherheit durch professionelle Desinfektion. Unser staatlich geprüfter Desinfektor berät Sie kompetent.',
    features: ['Desinfizierende Reinigungen', 'Beratung zu Hygieneplänen', 'Minimierung von Übertragungswegen', 'Präventionsmaßnahmen'],
    image: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?auto=format&fit=crop&q=80'
  }];
  return <div className="bg-white" data-id="element-442">
      {/* Hero */}
      <div className="bg-blue-900 text-white py-20" data-id="element-443">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-444">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-445">
            Unsere Leistungen
          </h1>
          <p className="text-xl text-blue-200 max-w-2xl mx-auto" data-id="element-446">
            Umfassende Reinigungskonzepte aus einer Hand. Professionell,
            zuverlässig und auf Ihre Bedürfnisse abgestimmt.
          </p>
        </div>
      </div>

      {/* Services List */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 space-y-24" data-id="element-447">
        {services.map((service, index) => <div key={service.id} className={`flex flex-col lg:flex-row gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-448">
            <div className="lg:w-1/2" data-id="element-449">
              <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]" data-id="element-450">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-451" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-452"></div>
              </div>
            </div>

            <div className="lg:w-1/2" data-id="element-453">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-454">
                {service.title}
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-455">
                {service.description}
              </p>

              <ul className="space-y-4 mb-8" data-id="element-456">
                {service.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-457">
                    <div className="bg-emerald-100 p-1 rounded-full mr-3 mt-0.5" data-id="element-458">
                      <Check className="w-4 h-4 text-emerald-600" data-id="element-459" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-460">{feature}</span>
                  </li>)}
              </ul>

              <Link to="/kontakt" data-id="element-461">
                <Button variant={index % 2 === 0 ? 'primary' : 'secondary'} data-id="element-462">
                  Angebot anfordern
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-463" />
                </Button>
              </Link>
            </div>
          </div>)}
      </div>

      {/* Bottom CTA */}
      <div className="bg-gray-50 py-16" data-id="element-464">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-465">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-466">
            Nicht das Richtige gefunden?
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-467">
            Wir erstellen gerne ein individuelles Reinigungskonzept für Ihre
            spezifischen Anforderungen. Sprechen Sie uns einfach an.
          </p>
          <Link to="/kontakt" data-id="element-468">
            <Button variant="outline" size="lg" data-id="element-469">
              Kontakt aufnehmen
            </Button>
          </Link>
        </div>
      </div>
    </div>;
}